export const apiPath = () => 'popup-maker/v2/settings';
